import React, {Component} from 'react';
import {connect} from 'react-redux';
import {axiosGetVehicleType, getVehicleType} from "../../store/common/actions";
import CarIcon from "@material-ui/icons/DirectionsCar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { createStyles, withStyles } from '@material-ui/core/styles';
import {selectVehicleType} from '../../store/common/actions';

const styles = theme => createStyles({
    choose: {
        display: 'flex',
        padding: '0 0 0 15px',
        marginBottom: 20,
        alignItems: 'center',
        minHeight: 48,
    },

    name: {
        width: '100%',
        textAlign: 'left',
        padding: '0 15px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },

    clear: {
        color: '#f00'
    },

    dialog: {
        width: '100%',
        margin: 30
    },

    dialog_item: {
        padding: '5px 10px',
        margin: '5px 0',

        ['&.selected']: {
            backgroundColor: '#f1f1f1'
        }
    }
});


class ChooseVehicle extends Component {
    state = {
        open: false
    };

    selectVehicle = (e, type_object) => {
        let current_types = this.props.selected_vehicles;

        if (e.currentTarget.checked) {
            current_types.push(type_object);
            this.checked(true, type_object);
        } else {
            current_types = current_types.filter(t => t.id !== type_object.id);
            this.checked(false, type_object);
        }

        this.props.selectVehicleType(current_types)
    };

    checked = (checked, type_object) => {
        let types = this.props.vehicles;
        const index = types.findIndex(t => t.id === type_object.id);

        types[index].checked = checked;

        this.props.getVehicleType([]);
        this.props.getVehicleType(types);
    };

    clear = () => {
        let types = this.props.vehicles;

        types = types.map(t => {
            t.checked = false;
            return t;
        });

        this.props.getVehicleType([]);
        this.props.getVehicleType(types);
        this.props.selectVehicleType([]);
    };

    componentDidMount() {
        this.props.axiosGetVehicleType();
    }

    render() {
        const {
            lng,
            classes,
            vehicles,
            selected_vehicles
        } = this.props;

        const {open} = this.state;

        const selected = selected_vehicles.map(s => {
            return s.name
        });
        const placeholder = (selected.length > 0) ? selected.join(', ') : lng.choose_vehicle_type;

        return (
            <React.Fragment>
                <Paper className={classes.choose} >
                    <CarIcon />
                    <Typography className={classes.name} onClick={() => this.setState({open: true})}>
                        {placeholder}
                    </Typography>
                    {selected.length > 0 &&
                        <IconButton>
                            <ClearIcon onClick={() => this.clear()} className={classes.clear}/>
                        </IconButton>
                    }
                </Paper>

                <Dialog
                    open={open}
                    onClose={() => this.setState({open: false})}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    PaperProps={{classes: {root: classes.dialog}}}
                >
                    <DialogTitle>{lng.choose_vehicle_type}</DialogTitle>
                    <DialogContent>
                        {vehicles.map(v => {
                            return (
                                <div key={v.id}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox checked={v.checked} value={v.id} onChange={(e) => this.selectVehicle(e,v)} />
                                        }
                                        label={v.name}
                                    />
                                </div>
                            )
                        })}
                    </DialogContent>
                </Dialog>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        lng: state.common.lng,
        vehicles: state.common.vehicleTypes,
        selected_vehicles: state.common.selectedVehicleTypes
    }
};

const mapDispatchToProps = {
    getVehicleType,
    axiosGetVehicleType,
    selectVehicleType
};

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(styles)(ChooseVehicle))